import Images from "../../../../../assets/js/Images"

export const step1 = [
  {
    name: "country",
    que: "Which country are you in?",
    options: [
      {
        label: "USA",
        value: "United States",
        imageType: "icon",
        image: Images?.flagUS,
      },
      {
        value: "India",
        label: "India",
        imageType: "icon",
        image: Images?.flagIN,
      },
    ]
  },
]

export const step2 = [
  {
    name: "preferredLanguage",
    que: "Which language would you prefer?",
    options: [
      {
        label: "English",
        value: "English",
        imageType: "icon",
        image: Images?.flagUS,
      },
      {
        label: "Spanish",
        value: "Spanish",
        imageType: "icon",
        image: Images?.flagES,
      },
    ]
  },
]

export const step3 = [
  {
    name: "preferredLanguage",
    que: "Which language would you prefer?",
    options: [
      {
        label: "English",
        value: "English",
        imageType: "icon",
        image: Images?.flagUS,
      },
      {
        label: "Hindi",
        value: "Hindi",
        imageType: "icon",
        image: Images?.flagIN,
      },
    ]
  },
]

export const step4 = [
  {
    name: "timezone",
    que: "What is the timezone for these countries?",
    options: [
      {
        imageType: "icon",
        image: Images?.earthAfrica,
        label: "Hawaii-Aleutian UTC -10:00",
        value: "Pacific/Honolulu",
      },
      {
        imageType: "icon",
        image: Images?.earthAfrica,
        label: "Alaska UTC -9:00",
        value: "America/Anchorage",
      },
      {
        imageType: "icon",
        image: Images?.earthAfrica,
        label: "Pacific UTC -8:00",
        value: "America/Los_Angeles",
      },
      {
        imageType: "icon",
        image: Images?.earthAfrica,
        label: "Mountain UTC -7:00",
        value: "America/Denver",
      },
      {
        imageType: "icon",
        image: Images?.earthAfrica,
        label: "Central UTC -6:00",
        value: "America/Chicago",
      },
      {
        imageType: "icon",
        image: Images?.earthAfrica,
        label: "Eastern UTC -5:00",
        value: "America/New_York",
      },
    ]
  },
]

export const step5 = [
  {
    name: "timezone",
    que: "What is the timezone for these countries?",
    options: [
      {
        imageType: "icon",
        label: "UTC+5:30 (IST)",
        value: "Asia/Kolkata",
        image: Images?.earthAsia,
      },
    ]
  },
]

export const step6 = [
  {
    name: "supportFor",
    que: "Who are you seeking support for today?",
    options: [
      {
        label: "Myself",
        value: "myself",
        imageType: "icon",
        image: Images.manRaisingHand,
      },
      {
        imageType: "icon",
        value: "partner&I",
        label: "My partner and I",
        image: Images.coupleWithHeart,
      },
      {
        imageType: "icon",
        value: "teenager",
        image: Images.adult,
        label: "My child/teenager",
      },
      {
        imageType: "icon",
        value: "seniorLovedOne",
        image: Images.olderAdult,
        label: "A senior loved one",
      },
      {
        value: "family",
        imageType: "icon",
        label: "My family as a whole",
        image: Images.manWomanGirlBoy,
      },
      {
        value: "else",
        imageType: "icon",
        label: "Someone else",
        image: Images.thoughtBalloon,
      },
    ]
  },
]